import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from './auth-store';

/** Guards all dashboard routes. Unauthenticated users are bounced to /login,
 *  preserving where they were headed so login can return them there. */
export function ProtectedRoute() {
  const status = useAuthStore((s) => s.status);
  const user = useAuthStore((s) => s.user);
  const mustChangePassword = useAuthStore((s) => s.mustChangePassword);
  const location = useLocation();

  if (status === 'idle') return null; // bootstrap in flight
  if (status !== 'authenticated' || !user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  const isClient = user.role === 'client';
  const changePwPath = '/client/change-password';

  // First-time clients must set a new password before doing anything else.
  if (isClient && mustChangePassword && location.pathname !== changePwPath) {
    return <Navigate to={changePwPath} replace />;
  }
  if (isClient && !mustChangePassword && location.pathname === changePwPath) {
    return <Navigate to="/client" replace />;
  }

  if (isClient && !location.pathname.startsWith('/client')) {
    return <Navigate to="/client" replace />;
  }

  if (!isClient && location.pathname.startsWith('/client')) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
